<script setup lang="ts">
const { getTranslation } = useLanguage();

const { main: { start: { title } } } = getTranslation();
</script>

<template>
  <section>
    <CommonContainer>
      <div class="2xs:px-12 xs:px-22">
        <h3 class="font-semibold leading-default-s text-3xl xs:text-4xl xs:max-w-[65%] sm:max-w-[60%] hd:max-w-[65%] 4k:leading-normal">
          <span v-for="(item, idx) in title.base">
            {{ title.base[idx] }}
            <span class="text-peach-300 mr-2">
              {{ title.keywords[idx] || '' }}
            </span>
          </span>
        </h3>
      </div>
    </CommonContainer>
  </section>
</template>
